import { Component } from '@angular/core';

@Component({
  selector: 'cr-avid-landing-page-generic',
  templateUrl: './landing-page-generic.component.html',
  styleUrls: ['./landing-page-generic.component.scss']
})
export class LandingPageGenericComponent {}
